import { render, staticRenderFns } from "./CooperativeDeclarationTab.vue?vue&type=template&id=dcf745fa&scoped=true"
import script from "./CooperativeDeclarationTab.vue?vue&type=script&lang=js"
export * from "./CooperativeDeclarationTab.vue?vue&type=script&lang=js"
import style0 from "./CooperativeDeclarationTab.vue?vue&type=style&index=0&id=dcf745fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf745fa",
  null
  
)

export default component.exports